import axios, { AxiosRequestConfig } from "axios";
import { buscaTipoLocal } from "../types/tipoLocalData";

export const getTipoLocal = async (token: string): Promise<buscaTipoLocal[]> => {
    try {
      const config: AxiosRequestConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      };
  
      const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipolocal`;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar tipos de locais:", error);
      throw error;
    }
  };